<template>
  <div>
    <h4 class="mb-4 bold text-overflow">
      Trình ký văn bản "{{ `${this.$route.query.name}` }}"
    </h4>
    <!-- Start Step -->
    <b-row class="mb-4">
      <b-col md="4" class="pl-0">
        <el-steps :active="activeProcess" finish-status="success">
          <el-step title="Chọn người ký"></el-step>
          <el-step title="Vị trí ký"></el-step>
        </el-steps>
      </b-col>
    </b-row>
    End Step
    <div v-if="activeProcess == 0">
      <b-row class="mb-3">
        <b-col md="12" class="left-side p-0">
          <div class="w-50 mr-3 mb-3">
            <el-input
              type="text"
              v-model="textFilter"
              placeholder="Tìm kiếm người dùng (Enter để tìm kiếm)"
              prefix-icon="fal fa-search"
              @keyup.enter.native="fn_getListDataByTab(true)"
              @input="forceUpdateUI"
            ></el-input>
          </div>
          <!-- Start Tab -->
          <el-tabs
            type="border-card"
            v-model="tabName"
            @tab-click="fn_handleClickTab"
          >
            <!-- Start Tab CaNhan -->
            <el-tab-pane name="CaNhan">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon icon24-Profile mr-2"></i>
                  <span>Chọn cá nhân</span>
                </div>
              </span>
              <div
                v-if="listPeopleFilter.length == 0"
                class="text-center center-block"
              >
                <h5 v-if="listPeopleFilter.length == 0" class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <!-- Start Tab Body -->
              <el-card
                shadow="hover"
                v-for="(emp, i) in listPeopleFilter"
                :key="i"
                :class="{
                  'card-item': true,
                  'checked': emp.value,
                }"
              >
                <b-form-checkbox
                  :data-id="emp.id"
                  v-model="emp.value"
                  @change="fn_toggleTag(emp)"
                  :disabled="emp.not_change"
                >
                  <el-avatar
                    :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                    class="ml-2 mr-2"
                  ></el-avatar>
                  <div>
                    <p class="bold mb-1 text-overflow-900">
                      {{ emp.administrative_info.name.full_name }}
                    </p>
                    <p>
                      {{ emp.employee_no }} •
                      {{
                        emp.administrative_info.phone_number
                          ? emp.administrative_info.phone_number
                          : "**** *** ***"
                      }}
                      {{ emp.position_name ? "• " + emp.position_name : "" }}
                    </p>
                  </div>
                </b-form-checkbox>
              </el-card>
              <!-- Start Tab Body -->
            </el-tab-pane>
            <!-- End Tab CaNhan -->

            <!-- Start Tab GanDay -->
            <el-tab-pane name="GanDay">
              <span slot="label">
                <div class="d-flex justify-content-center align-items-center">
                  <i class="icon isax-clock mr-2"></i>
                  <span>Chọn gần đây</span>
                </div>
              </span>
              <div v-if="this.listNearestHistory.length == 0" class="text-center center-block">
                <h5 class="empty__tab-text">Không có dữ liệu.</h5>
              </div>
              <!-- Start Tab Body -->
              <template v-else>
                <el-card
                  shadow="hover"
                  v-for="(emp, i) in this.listNearestHistory"
                  :key="i"
                  :class="{
                    'card-item': true,
                    'checked': emp.value,
                  }"
                >
                  <b-form-checkbox
                    :data-id="emp.id"
                    v-model="emp.value"
                    @change="fn_toggleTag(emp)"
                    :disabled="emp.not_change"
                  >
                    <el-avatar
                      :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                      class="ml-2 mr-2"
                    ></el-avatar>
                    <div>
                      <p class="bold mb-1 text-overflow-900">
                        {{ emp && emp.administrative_info ? emp.administrative_info.name.full_name : '' }}
                      </p>
                      <p>
                        {{ emp.employee_no }} •
                        {{
                         emp && emp.administrative_info && emp.administrative_info.phone_number
                            ? emp.administrative_info.phone_number
                            : "**** *** ***"
                        }}
                        {{ emp.position_name ? "• " + emp.position_name : "" }}
                      </p>
                    </div>
                  </b-form-checkbox>
                </el-card>
              </template>
            </el-tab-pane>
            <!-- End Tab GanDay -->
          </el-tabs>
          <!-- End Tab -->
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col :md="mData.dataForm.publish && mData.dataForm.publish.is_auto ? 6 : 8" class="p-0">
          <p v-if="!mData.dataForm.signers || mData.dataForm.signers.length == 0" class="bold mt-2">
            <span class="bold" style="font-size: 14px">Đến:</span>
            <span style="color: #7e7e7e">
              "Vui lòng chọn ít nhất 1 người nhận"</span
            >
          </p>
          <b-row v-if="updateListTagUI && mData.dataForm.signers.length > 0">
            <b-col md="1" class="pl-0 pr-1" style="margin-top: 7px">
              <span class="bold" :style="mData.dataForm.publish && mData.dataForm.publish.is_auto ? 'display: inline-block;width: max-content;' : ''"
                >Đến ({{ mData.dataForm.signers.length }}):</span
              >
            </b-col>
            <b-col md="11" class="p-0">
              <el-tag
                class="mb-2 mr-2"
                :key="tag.id"
                v-for="(tag, i) in mData.dataForm.signers"
                :disable-transitions="false"
                :data-id="tag.id"
                :title="`${
                  tag.name +
                  (tag.position_name ? ' (' + tag.position_name + ')' : '')
                }`"
              >
                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    h-100
                  "
                >
                  <el-avatar
                    size="small"
                    :src="tag.avt ? tag.avt : 'img/Vector-person.png'"
                    class="ml-2 mr-2"
                  ></el-avatar>
                  <div class="d-flex align-items-center">
                    <p class="tag__name-overflow mr-1">{{ tag.name }}</p>
                    <p>
                      {{ tag.position_name ? `(${tag.position_name})` : "" }}
                    </p>
                  </div>
                  <i
                    v-if="!tag.not_change"
                    class="el-tag__close el-icon-close"
                    @click="fn_closeTag(tag, i)"
                  ></i>
                </div>
              </el-tag>
            </b-col>
          </b-row>
        </b-col>
        <b-col :md="mData.dataForm.publish && mData.dataForm.publish.is_auto ? 6 : 4" class="p-0">
          <div class="d-flex justify-content-end align-items-center">
            <div class="d-flex justify-content-end align-items-center issued-at" v-if="mData.dataForm.publish && mData.dataForm.publish.is_auto">
              <h6 class="bold" style="width: 120px">Nơi ban hành</h6>
              <el-select v-model="mData.dataForm.publish.department_id" placeholder="">
                <el-option
                  v-for="item in listDepaterments"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="d-flex justify-content-end align-items-center ml-3">
              <label class="bold" style="width: 50px; margin-bottom: 0; display: inline-flex; align-items: baseline;"></label>
              <h6 class="bold" style="width: 80px">Hạn xử lý</h6>
              <el-date-picker
                class="datePicker"
                type="date"
                v-model="mData.dataForm.deadline"
                placeholder="Chọn"
                format="dd/MM/yyyy"
                prefix-icon="isax-calendar-1"
                :clearable="false"
                :picker-options="pickerOptionFrom"
              ></el-date-picker>
            </div>
          </div>
          <!-- Start Manipulate button -->
          <div class="text-right mt-3 pb-3 pr-0">
            <el-button class="btn__doc btn__doc-back" @click="fn_goBackPrevious"
              >Quay lại</el-button
            >
            <el-button
              v-if="viewMode == 'choose-signer'"
              :disabled="!mData.dataForm.signers || mData.dataForm.signers.length == 0 || (mData.dataForm.publish.is_auto == true && !mData.dataForm.publish.department_id)"
              class="btn__doc btn__doc-transfer"
              @click="fn_submitForm('next-to-sign-request')"
              >Tiếp theo
            </el-button>
          </div>
          <!-- End Manipulate button -->
        </b-col>
      </b-row>
    </div>
    <div v-if="activeProcess == 1">
      <!-- Start Preview File -->
      <div class="body-pdf">
        <div
          class="pdf-container"
          :style="
            drawerVisible ? 'right: 0%; width: 75%' : 'right: 0%; width: 98%'
          "
        >
          <div
            class="dropzone"
            :style="{
              maxWidth:
                canvasDimensions.width > 0
                  ? canvasDimensions.width + 'px'
                  : '833px',
            }"
          >
            <div class="pdf-content" id="pdf-content">
              <div
                class="canvas text-center pdfViewer singlePageView nopadding"
              >
                <Draggable
                  v-if="!changedSignImage"
                  ref="signatureDraggable"
                  @endDragSign="endDragSign"
                  @draggingSign="endDragSign"
                  :imageSignId="imgSignId"
                  :pageNum="pageNum"
                  :positionSign="dataObject.position"
                  :currentPage="pageNum"
                  :from="imgSignId ? 'DrafDocument' : ''"
                  @removeSignImage="fn_deleteSignImage"
                />
                <ViewPdf
                  @changePageNum="changePageNum"
                  @canvasDimensions="handleCanvasDimensions"
                  @pdfSize="handlePdfSize"
                  :fileId="fileId"
                  :currentPage="pageNum"
                  :pageSign="pageSign"
                />
              </div>
            </div>
            <div class="paging ml-26 text-center">
              <p>
                Trang
                <el-input-number
                  class="current-page ml-1 mr-1"
                  :controls="false"
                  v-model="pageNum"
                  @change="changePage(pageNum)"
                  :min="1"
                  :max="numPages"
                ></el-input-number>
                / {{ numPages }}
              </p>
            </div>
          </div>
        </div>
        <div>
          <!-- Start Drawer -->
          <div class="drawer-container">
            <!-- Start full drawer -->
            <div v-if="drawerVisible" class="drawer">
              <div class="drawer__header d-flex align-items-center">
                <i
                  class="icon el-icon-d-arrow-right mt-1 mr-2"
                  @click="fn_toggleDrawer"
                ></i>
                <p class="drawer__header-title">Thanh công cụ</p>
              </div>

              <!-- Start main Sign images -->
              <div class="drawer__box">
                <p class="drawer__box-title">Chữ ký cá nhân</p>
                <div class="drawer__box-content">
                  <p
                    v-if="fileUploadOption.FileChuKy.listImageSigns.length == 0 && isClickTagChooseSignature"
                    class="empty__tab-text text-center"
                  >
                    Không có dữ liệu.
                  </p>
                  <p
                    v-if="fileUploadOption.FileChuKy.listImageSigns.length == 0 && !isClickTagChooseSignature"
                    class="empty__tab-text text-center"
                  >
                    Vui lòng chọn người ký bên dưới để cấu hình chữ ký.
                  </p>
                  <!-- Start list Sign image -->
                  <div v-else class="list-sign-image" id="selectorContainer">
                    <el-radio-group
                      v-model="imgSignId"
                      class="radio-group"
                      @change="changeSignImage(imgSignId)"
                    >
                      <el-radio
                        v-for="(item, index) in fileUploadOption.FileChuKy
                          .listImageSigns"
                        :key="index"
                        :label="item.sign_image_id"
                      >
                        <div class="border-image">
                          <el-image :src="item.url" fit="cover"></el-image>
                        </div>
                      </el-radio>
                    </el-radio-group>
                    <!-- <div class="border-image">
                      <el-upload
                        :auto-upload="false"
                        drag
                        action
                        multiple
                        :accept="fileUploadOption.FileChuKy.accept"
                        :on-change="fn_uploadSign"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Kéo vào đây <br />
                          hoặc <em>click để upload</em>
                        </div>
                      </el-upload>
                    </div> -->
                  </div>
                  <!-- End list Sign images -->
                </div>
              </div>
              <!-- End main Sign images -->

              <!-- Start Other Sign images -->
              <!-- <div class="drawer__box">
                <p class="drawer__box-title">Con dấu tổ chức</p>
                <div class="drawer__box-content">
                  <p
                    v-if="mData.dataDefault.listCompanySign == 0"
                    class="empty__tab-text text-center"
                  >
                    Không có dữ liệu.
                  </p>
                  <div v-else class="list-sign-image">
                    <el-radio-group
                      v-model="imgSignId"
                      class="radio-group"
                      @change="changeSignImage(imgSignId)"
                    >
                      <el-radio
                        v-for="(item, index) in mData.dataDefault
                          .listCompanySign"
                        :key="index"
                        :label="item.sign_image_id"
                      >
                        <div class="border-image">
                          <el-image :src="item.url" fit="cover"></el-image>
                        </div>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div> -->
              <!-- End Other Sign images -->
            </div>
            <!-- End full drawer -->
            <!-- Start collapse drawer -->
            <div class="drawer-collapse" v-else>
              <div>
                <div
                  class="drawer__header d-flex align-items-center"
                  style="cursor: pointer"
                  @click="fn_toggleDrawer"
                >
                  <i class="icon el-icon-d-arrow-left mb-1"></i>
                  <p class="drawer__header-title">Thanh công cụ</p>
                </div>
              </div>
            </div>
            <!-- End collapse drawer -->
          </div>
          <!-- End Drawer -->
        </div>
      </div>
      <b-row>
        <b-col md="8" class="pl-0 pt-3">
          <b-row>
            <b-col md="1" class="p-0" style="margin-top: 7px">
              <span class="bold"
                >Đến ({{ mData.dataForm.signers.length }}):</span
              >
            </b-col>
            <b-col md="11" class="p-0">
              <el-radio-group size="mini" v-model="targetSigner">
                <el-radio-button
                  v-for="(tag, i) in mData.dataForm.signers"
                  :key="i"
                  :label="`${tag.user_id}-${tag.position_id}`"
                  :title="`${
                    tag.name +
                    (tag.position_name ? ' (' + tag.position_name + ')' : '')
                  }`"
                  :disabled="tag.status == 'SIGNED' || tag.is_VT && tag.is_add_auto ? true : false"
                >
                  <div
                    class="
                      d-flex
                      justify-content-between
                      align-items-center
                      h-100
                    "
                    @click="fn_clickTag(tag)"
                  >
                    <el-avatar
                      size="small"
                      :src="tag.avt ? tag.avt : 'img/Vector-person.png'"
                      class="ml-2 mr-2"
                    ></el-avatar>
                    <p class="tag__name-overflow mr-1">{{ tag.name }}</p>
                    <p>
                      {{ tag.position_name ? `(${tag.position_name})` : "" }}
                    </p>
                    <i
                      :class="{
                        'icon ml-1': true,
                        'el-icon-check cursor-notAllow': tag.is_has_sign || tag.is_VT && tag.is_add_auto,
                        'icon24-VB_ChoKyDuyet': !tag.is_has_sign
                      }"
                    ></i>
                  </div>
                </el-radio-button>
              </el-radio-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="4" class="p-0">
          <!-- Start Manipulate button -->
          <div class="text-right mt-3 pb-3 pr-0">
            <el-button class="btn__doc btn__doc-back" @click="fn_goBackPrevious"
              >Quay lại</el-button
            >
            <el-button
              v-if="viewMode == 'sign-request'"
              :disabled="!fn_checkAllSignersHaveSignImg()"
              class="btn__doc btn__doc-transfer"
              @click="fn_submitForm('sign-request')"
              >Trình ký</el-button
            >
          </div>
          <!-- End Manipulate button -->
        </b-col>
      </b-row>
      <!-- End Preview File -->
    </div>
  </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
// import SignatureDigitalService from "../../../service/SignatureDigitalService";
import MethodService from "../../../service/MethodService";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import DocumentApi from "../../../moduleApi/DocumentApi";
import DepartmentApi from '../../../moduleApi/DepartmentApi';
import EmployeeRoleApi from "../../../moduleApi/EmployeeRoleApi";
import FileApi from "../../../moduleApi/FileApi";
import RoleApi from "../../../moduleApi/RoleApi";
import { dataDocMixins } from "./DocumentMixins/dataDocMixins";
import { fnDocMixins } from "./DocumentMixins/fnDocMixins";
import VueDocPreview from "vue-doc-preview";
import ViewPdf from "@/component/Draggable/ViewPdf";
import EmployeeSignatureApi from "@/moduleApi/EmployeeSignatureApi";
import Draggable from "@/component/Draggable/Draggable";
import { Filter } from "mushroomjs";
import EventBus from "@/service/EventBus";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    VueDocPreview,
    ViewPdf,
    Draggable,
  },
  data() {
    return {
      ExtensionService,
      signers: [],
      targetSigner: null,
      fileId: "",
      url: "",
      activeProcess: 0,

      tabName: "",
      textFilter: "",
      listPeopleFilter: [],
      listDepaterments: [],

      defaultProps: {
        children: "children",
        label: "label",
      },

      drawerVisible: true,

      imgSignId: undefined,
      listEmployeeSignatures: [],
      fileUploadOption: {
        FileChuKy: {
          accept: ".png",
          dialogImageUrl: "",
          listImageSigns: [],
        },
      },
      pageNum: 1,
      pageSign: 0,
      numPages: 0,
      changedSignImage: true,
      historySign: {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 150,
        height: 150,
        page_index: 1
      },
      haveHistory: false,
      dataObject: {},
      currentEmployeeInfo: MethodService.getEmployeeInfo(),
      updateListTagUI: false,
      isClickTagChooseSignature: false,
      canvasDimensions: { width: 0, height: 0 },
      pdfSize: { width: 0, height: 0 }
    };
  },

  watch: {
    textFilter(val) {
      if (this.tabName == "DonVi") this.$refs.organizationModelTree.filter(val);
      if (this.tabName == "Nhom") this.$refs.businessTree.filter(val);
    },
    dataObject(newVal, oldVal) {
      setTimeout(() => {
        if (this.dataObject.sign_image_id) {
          const previewPosition = this.fn_getCanvasPositionFromSigner(
            this.dataObject.position
          );
          const previewSize = this.fn_getDisplaySignerSize(
            this.dataObject.position
          );
          this.imgSignId = this.dataObject.sign_image_id;
          this.historySign = {
            imageSignId: this.dataObject.sign_image_id,
            pageSigned: this.dataObject.position.page_index,
            positionX: previewPosition.x,
            positionY: previewPosition.y,
            width: previewSize.width,
            height: previewSize.height,
          }
          this.dataObject.position = {
            ...this.dataObject.position,
            x: previewPosition.x,
            y: previewPosition.y,
            width: previewSize.width,
            height: previewSize.height,
          };
          this.checkHaveHistorySign()
          this.showChangeSignImage()
        }
      }, 1000)
    },
  },

  methods: {
    fn_getCanvasOffsetInPreview() {
      const root = this.$el;
      const canvas = root ? root.querySelector(".dropzone canvas") : null;
      const container = root ? root.querySelector(".dropzone .canvas") : null;
      if (!canvas || !container) {
        return { x: 0, y: 0 };
      }
      const canvasRect = canvas.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      return {
        x: Math.round(canvasRect.left - containerRect.left),
        y: Math.round(canvasRect.top - containerRect.top),
      };
    },

    fn_getPageRelativePreviewPosition(position = {}) {
      const A4_WIDTH_96DPI = 793.7008;
      const A4_HEIGHT_96DPI = 1122.5197;
      const canvasW =
        this.canvasDimensions.width > 0 ? this.canvasDimensions.width : 833;
      const canvasH =
        this.canvasDimensions.height > 0 ? this.canvasDimensions.height : 1179;
      const offset = this.fn_getCanvasOffsetInPreview();

      if (position.__displayNormalized) {
        return {
          x: Math.round((position.x != null ? position.x : 0) - offset.x),
          y: Math.round((position.y != null ? position.y : 0) - offset.y),
        };
      }

      if (this.fn_hasCanonicalBackendPosition(position)) {
        const x = position.x != null ? position.x : 0;
        const y = position.y != null ? position.y : 0;
        return {
          x: Math.round((x * canvasW) / A4_WIDTH_96DPI),
          y: Math.round((y * canvasH) / A4_HEIGHT_96DPI),
        };
      }

      if (this.fn_hasMeaningfulDelta(position)) {
        return {
          x: Math.round(position.delta_x),
          y: Math.round(position.delta_y),
        };
      }

      return {
        x: Math.round(position.x != null ? position.x : 0),
        y: Math.round(position.y != null ? position.y : 0),
      };
    },

    fn_hasMeaningfulDelta(position = {}) {
      const dx = position.delta_x;
      const dy = position.delta_y;
      return (
        dx != null &&
        dy != null &&
        (Math.abs(dx) > 2 || Math.abs(dy) > 2)
      );
    },

    fn_hasCanonicalBackendPosition(position = {}) {
      const x = Number(position.x);
      const y = Number(position.y);
      if (!(Number.isFinite(x) && Number.isFinite(y) && (x > 0 || y > 0))) {
        return false;
      }

      if (this.fn_hasMeaningfulDelta(position)) {
        return this.fn_isBackendScaledPosition(position);
      }

      return true;
    },

    fn_getCanvasPositionFromSigner(position = {}) {
      const pagePosition = this.fn_getPageRelativePreviewPosition(position);
      const offset = this.fn_getCanvasOffsetInPreview();
      return {
        x: pagePosition.x + offset.x,
        y: pagePosition.y + offset.y,
      };
    },

    fn_isBackendScaledPosition(position = {}) {
      if (!this.fn_hasMeaningfulDelta(position)) return false;

      const dx = position.delta_x != null ? position.delta_x : 0;
      const dy = position.delta_y != null ? position.delta_y : 0;
      const x = position.x != null ? position.x : 0;
      const y = position.y != null ? position.y : 0;

      return Math.abs(x - dx) > 2 || Math.abs(y - dy) > 2;
    },

    fn_getDisplaySignerSize(position = {}) {
      const A4_WIDTH_96DPI = 793.7008;
      const A4_HEIGHT_96DPI = 1122.5197;
      const BE_DELTA = 1;
      const canvasW =
        this.canvasDimensions.width > 0 ? this.canvasDimensions.width : 833;
      const canvasH =
        this.canvasDimensions.height > 0 ? this.canvasDimensions.height : 1179;

      const width = position.width || 220;
      const height = position.height || 180;

      if (position.__displayNormalized) {
        return {
          width: Math.max(80, Math.min(width, 320)),
          height: Math.max(80, Math.min(height, 320)),
        };
      }

      if (!this.fn_hasCanonicalBackendPosition(position)) {
        return {
          width: Math.max(80, Math.min(width, 320)),
          height: Math.max(80, Math.min(height, 320)),
        };
      }

      return {
        width: Math.max(
          80,
          Math.min(
            Math.round((width * BE_DELTA * canvasW) / A4_WIDTH_96DPI),
            320
          )
        ),
        height: Math.max(
          80,
          Math.min(
            Math.round((height * BE_DELTA * canvasH) / A4_HEIGHT_96DPI),
            320
          )
        ),
      };
    },

    applySignerCanvasPosition(position = {}) {
      const canvasPosition = this.fn_getCanvasPositionFromSigner(position);
      const previewSize = this.fn_getDisplaySignerSize(position);
      this.dataObject.position = {
        ...position,
        x: canvasPosition.x != null ? canvasPosition.x : 0,
        y: canvasPosition.y != null ? canvasPosition.y : 0,
        width: previewSize.width,
        height: previewSize.height,
        __displayNormalized: true,
      };
      this.historySign.positionX =
        canvasPosition.x != null ? canvasPosition.x : 0;
      this.historySign.positionY =
        canvasPosition.y != null ? canvasPosition.y : 0;
      this.historySign.width = previewSize.width;
      this.historySign.height = previewSize.height;
      this.historySign.pageSigned = position.page_index || this.pageNum;
    },

    getDefaultDisplaySignSize(img) {
      const sourceWidth = img && img.width > 0 ? img.width : 220;
      const sourceHeight = img && img.height > 0 ? img.height : 160;
      const maxWidth = 220;
      const maxHeight = 220;
      const minWidth = 120;
      const minHeight = 90;
      const scale = Math.min(maxWidth / sourceWidth, maxHeight / sourceHeight, 1);
      let width = Math.round(sourceWidth * scale);
      let height = Math.round(sourceHeight * scale);

      if (width < minWidth) {
        const ratio = minWidth / width;
        width = minWidth;
        height = Math.round(height * ratio);
      }
      if (height < minHeight) {
        const ratio = minHeight / height;
        height = minHeight;
        width = Math.round(width * ratio);
      }

      if (width > 320) {
        const ratio = 320 / width;
        width = 320;
        height = Math.round(height * ratio);
      }
      if (height > 320) {
        const ratio = 320 / height;
        height = 320;
        width = Math.round(width * ratio);
      }

      return { width, height };
    },

    fn_toBackendSignPosition(position = {}) {
      const rawPosition = this.fn_getPageRelativePreviewPosition(position);
      const width = position.width || 150;
      const height = position.height || 150;

      return {
        delta_x: rawPosition.x != null ? rawPosition.x : 0,
        delta_y: rawPosition.y != null ? rawPosition.y : 0,
        x: rawPosition.x != null ? rawPosition.x : 0,
        y: rawPosition.y != null ? rawPosition.y : 0,
        width: Math.round(width),
        height: Math.round(height),
        page_index: position.page_index,
      };
    },

    fn_syncCurrentSignerPosition() {
      const dragEl = this.$el ? this.$el.querySelector(".dropzone .draggable") : null;
      const canvasContainer = this.$el ? this.$el.querySelector(".dropzone .canvas") : null;
      if (dragEl && canvasContainer && this.imgSignId) {
        const dragRect = dragEl.getBoundingClientRect();
        const containerRect = canvasContainer.getBoundingClientRect();
        this.endDragSign({
          imageSignId: this.imgSignId,
          pageSigned: this.pageNum,
          positionX: Math.round(dragRect.left - containerRect.left),
          positionY: Math.round(dragRect.top - containerRect.top),
          width: Math.round(dragRect.width),
          height: Math.round(dragRect.height),
        });
        return;
      }

      const draggableRef = this.$refs.signatureDraggable;
      const draggable =
        Array.isArray(draggableRef) && draggableRef.length > 0
          ? draggableRef[0]
          : draggableRef;
      if (
        draggable &&
        typeof draggable.getCurrentPosition === "function" &&
        this.imgSignId
      ) {
        const currentPosition = draggable.getCurrentPosition();
        this.endDragSign(currentPosition);
      } else if (this.historySign && this.historySign.imageSignId) {
        this.fn_saveSignPosition();
      }
    },

    fn_handleClickTab(tab, event) {
      this.tabName = tab.name;
      this.textFilter = '';
      if (this.tabName == "CaNhan") this.listPeopleFilter = this.listPeopleFilterRaw;
      else if (this.tabName == "GanDay") {
        this.listNearestHistory =
          this.listSignRequestHistory.filter(person => person.administrative_info);
      }
      this.forceUpdateUI();
    },

    async fn_getListDataByTab(isSearch) {
      if (this.tabName == "CaNhan") {
        this.fn_getDataTabIndividual(isSearch);
      } else if (this.tabName == "GanDay") {
        this.fn_getDataTabNearest();
      }
    },

    async fn_getDataTabIndividual(isSearch) {
      const filter = Filter.and(
        Filter.eq("status", "DANG_LAM_VIEC"),
        Filter.ne("disabled", true),
        Filter.or(
          Filter.regex("employee_no", this.textFilter, "i"), // x:regex_i:ab[cd]
          Filter.regex("administrative_info.email", this.textFilter, "i"),
          Filter.regex("administrative_info.name.full_name", this.textFilter, "i"),
        )
      ).build();
      const employeeApiRes = await EmployeeApi.list({
        limit: 5000,
        fields: "administrative_info,employee_no,job_info,status",
        filters: this.textFilter
          ? filter
          : "status=DANG_LAM_VIEC&disabled!=true",
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.listPeopleFilter = await this.fn_changeData(
          employeeApiRes.result
        );
        this.fn_checkSignerEditable(this.listPeopleFilter);
        await this.fn_checkSignerFromDetail(
          this.mData.dataForm.signers ? this.mData.dataForm.signers : []
        );
        await this.fn_checkSignerFromTag();
        if (!isSearch) this.listPeopleFilterRaw = this.listPeopleFilter;
      } else {
        this.listPeopleFilter = [];
      }
    },

    fn_getDataTabNearest() {
      this.listSignRequestHistory = this.listSignRequestHistory.filter(person => person.administrative_info);
      this.listNearestHistory =
        this.listSignRequestHistory.filter(
          (person) =>
            (person.name_filter && person.name_filter.includes(this.textFilter.toLowerCase())) ||
            (person.employee_no && person.employee_no.includes(this.textFilter)) ||
            (person.administrative_info && person.administrative_info.name.full_name.includes(this.textFilter)) ||
            (person.administrative_info && person.administrative_info.email.includes(this.textFilter))
        );
    },

    fn_checkSignerEditable(arrPeople, isNearest) {
      if (
        this.mData.dataForm.signers &&
        this.mData.dataForm.signers.length > 0
      ) {
        this.mData.dataForm.signers.forEach((signer) => {
          arrPeople.forEach((person) => {
            if (
              (signer.user_id == person.signer_id && signer.position_id == person.position_id &&
                isNearest &&
                (signer.status == "SIGNED" ||
                  signer.status == "SIGNING" ||
                  signer.status == "SIGNED_FAILED")) ||
              (signer.user_id == person.id && signer.position_id == person.position_id &&
                !isNearest &&
                (signer.status == "SIGNED" ||
                  signer.status == "SIGNING" ||
                  signer.status == "SIGNED_FAILED"))
            ) {
              person.not_change = true;
            }
          });
        });
      }
    },

    fn_checkAllSignersHaveSignImg() {
      const o = this.mData.dataForm.signers.find((tag) => !tag.position && !tag.is_add_auto);
      if (o) return false;
      return true;
    },

    fn_checkSignerFromDetail(listSigner) {
      if (listSigner.length > 0) {
        listSigner.forEach((signer) => {
          this.listPeopleFilter.forEach((person) => {
            if (person.id == signer.user_id && person.position_id == signer.position_id) {
              person.value = true;
              this.fn_toggleTag(person);
            }
          });
          this.listNearestHistory.forEach((person) => {
            if (person.signer_id == signer.user_id && person.position_id == signer.position_id) {
              person.value = true;
            }
          });
        });
      }
      // Force update UI
      if (listSigner.length > 0) this.updateListTagUI = true;
    },

    fn_checkSignerFromTag() {
      if (this.mData.dataForm.signers.length > 0) {
        this.listPeopleFilter.forEach((person) => {
          this.mData.dataForm.signers.forEach((tag) => {
            if (person.id == tag.id && person.position_id == tag.position_id) {
              person.value = true;
            }
          });
        });
      }
    },

    fn_changeDataSigner(data) {
      data.forEach((e) => {
        // check status employee
        e.not_change =
          e.status == "SIGNED" ||
          e.status == "SIGNING" ||
          e.status == "SIGNED_FAILED"
            ? true
            : false;

        let pos = "";
        if (e.job_info && e.job_info.length > 0) {
          pos = this.mData.dataDefault.listPosition.find(
            (position) => position.id == e.job_info[0].position_id
          );
        } else {
          pos = this.mData.dataDefault.listPosition.find(
            (position) => position.id == e.position_id
          );
        }
        const emp = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == e.id || emp.id == e.user_id
        );
        e.name = emp ? emp.administrative_info.name.full_name : "---";
        e.employee_no = emp ? emp.employee_no : "---";

        if (pos && pos.name) {
          e.position_id = pos.id;
          e.position_name = pos.name;
        } else {
          if (emp && emp.job_info && emp.job_info.length > 0) {
            const o = this.mData.dataDefault.listPosition.find(
              (position) => position.id == emp.job_info[0].position_id
            );
            e.position_id = emp.job_info[0].position_id;
            e.position_name = o ? o.name : "";
          } else {
            e.position_id = null;
            e.position_name = null;
          }
        }
        e.value = false;
        e.avt = emp && emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512" :
                emp.administrative_info && emp.administrative_info.avatar_id ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                : "";
      });
      return data;
    },

    fn_changeData(data) {
      let listResult = [];
      data.forEach(person => {
        // check status employee
        person.not_change =
          (person.status == "SIGNED" ||
          person.status == "SIGNING" ||
          person.status == "SIGNED_FAILED")
            ? true
            : false;
        const emp = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == person.id
        );
        person.avt = emp && emp.image_id ? ExtensionService.urlImg + emp.image_id + "&r=square&w=512" :
                emp.administrative_info && emp.administrative_info.avatar_id ? ExtensionService.urlImg + emp.administrative_info.avatar_id + "&r=square&w=512"
                : "";
        person.employee_no = emp ? emp.employee_no : "---";
        person.value = person.value == true ? person.value : false;

        if (person.job_info && person.job_info.length > 0) {
          person.job_info = MethodService.getValidJobInfo(person.job_info, this.mData.dataDefault.listContractTypeId);
          person.job_info.forEach((job) => {
            let e1 = {...person};
            const pos = this.mData.dataDefault.listPosition.find(
            (position) => position.id == job.position_id
            );
            e1.position_id = job.position_id;
            e1.position_name = pos ? pos.name : "";
            if (e1.position_id)
              listResult.push(e1);
          });
        } else {
          listResult.push(person);
        }
      });
      return listResult;
    },

    fn_closeTag(tag) {
      this.mData.dataForm.signers.splice(
        this.mData.dataForm.signers.indexOf(tag),
        1
      );
      this.listPeopleFilter.forEach((person) => {
        if (person.id == tag.user_id && person.position_id == tag.position_id) {
          person.value = false;
          return;
        }
      });
      this.listNearestHistory.forEach((person) => {
        if (person.signer_id == tag.user_id && person.position_id == tag.position_id) {
          person.value = false;
          return;
        }
      });
    },

    async fn_checkEmployeeHasSign(empId) {
      const employeeSignatureApiRes = await EmployeeSignatureApi.list(
        { filters: `employee_id=${empId}`}
      );
      if (
        employeeSignatureApiRes.result &&
        employeeSignatureApiRes.result.length > 0 &&
        employeeSignatureApiRes.result[0].image_ids &&
        employeeSignatureApiRes.result[0].image_ids.length > 0
      ) {
        return true;
      } else return false;
    },

    fn_toggleCard(emp) {
      if (this.tabName == "CaNhan") {
        const indexEmployee1 = this.listPeopleFilter.findIndex(e => e.id == emp.id && e.position_id == emp.position_id);
        if (indexEmployee1 >= 0) this.listPeopleFilter[indexEmployee1].value = false;

        const indexEmployee2 = this.listNearestHistory.findIndex(e => e.signer_id == emp.id && e.position_id == emp.position_id);
        if (indexEmployee2 >= 0) this.listNearestHistory[indexEmployee2].value = false;
      } else if (this.tabName == "GanDay") {
        const indexEmployee1 = this.listPeopleFilter.findIndex(e => e.id == emp.signer_id && e.position_id == emp.position_id);
        if (indexEmployee1 >= 0) this.listPeopleFilter[indexEmployee1].value = false;

        const indexEmployee2 = this.listNearestHistory.findIndex(e => e.signer_id == emp.signer_id && e.position_id == emp.position_id);
        if (indexEmployee2 >= 0) this.listNearestHistory[indexEmployee2].value = false;
      }
    },

    async fn_toggleTag(emp) {
      let isDuplicate = "";
      if (this.tabName == "CaNhan") {
        isDuplicate = this.mData.dataForm.signers.find(
          (e) => e.user_id == emp.id && e.position_id == emp.position_id
        );
      } else if (this.tabName == "GanDay") {
        isDuplicate = this.mData.dataForm.signers.find(
          (e) => e.user_id == emp.signer_id && e.position_id == emp.position_id
        );
      }

      if (emp.value && !isDuplicate) {
        // Check Employee Position
        if (!emp.position_id) {
          this.$notify.info({
            message: `Nhân viên hiện tại không có chức vụ.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_toggleCard(emp);
          return;
        }
        // Check Employee has sign ?
        const employeeHasSignature = await this.fn_checkEmployeeHasSign(this.tabName == "CaNhan" ? emp.id : emp.signer_id);
        if (!employeeHasSignature) {
          this.$notify.info({
            message: `Nhân viên hiện tại không có chữ ký.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_toggleCard(emp);
          return;
        }

        const pos = this.mData.dataDefault.listPosition.find(
          (position) => position.id == emp.position_id
        );
        this.updateListTagUI = false;
        this.mData.dataForm.signers.push({
          user_id: this.tabName == "CaNhan" ? emp.id : emp.signer_id,
          name: emp.administrative_info.name.full_name,
          avt: emp.avt,
          job_info: emp.job_info,
          position_name: emp.position_name ? pos.name : pos && pos.name ? pos.name : "",
          position_id: emp.position_id,
          is_has_sign: false,
          not_change: false,
        });
        this.updateListTagUI = true;
      } else if (!emp.value && isDuplicate) {
        this.updateListTagUI = false;
        this.mData.dataForm.signers = this.mData.dataForm.signers.filter(
          (tag) => {
            if (this.tabName == "CaNhan") {
              return (tag.user_id != emp.id && tag.position_id != emp.position_id) ||
                (tag.user_id == emp.id && tag.position_id != emp.position_id) ||
                (tag.user_id != emp.id && tag.position_id == emp.position_id);
            } else if (this.tabName == "GanDay") {
              return (tag.user_id != emp.signer_id && tag.position_id != emp.position_id) ||
                (tag.user_id == emp.signer_id && tag.position_id != emp.position_id) ||
                (tag.user_id != emp.signer_id && tag.position_id == emp.position_id);
            }
          }
        );
        this.updateListTagUI = true;
      }
      this.fn_toggleCardForManipulatelyTab(emp);
    },

    fn_toggleCardForManipulatelyTab(emp) {
      // Toggle card for other tabs
      if (this.tabName == "CaNhan") {
        this.listNearestHistory.forEach((person) => {
          if (person.signer_id == emp.id && person.position_id == emp.position_id) {
            person.value = !person.value;
            return;
          }
        });
      } else {
        this.listPeopleFilter.forEach((person) => {
          if (person.id == emp.signer_id && person.position_id == emp.position_id) {
            person.value = !person.value;
            return;
          }
        });
      }
    },

    //Lấy dữ liệu nhân viên theo người tạo
    async getListDepartermentByEmployee() {
      let validJobInfo = MethodService.getValidJobInfo(
        this.currentEmployeeInfo.job_info, this.mData.dataDefault.listContractTypeId
      );
      //Nếu không có Job_info nào còn hiệu lực thì không lấy danh sách tất cả phòng ban
      if (!validJobInfo || validJobInfo.length == 0) this.getDepartermentByIds();
      let arrDepartmentIds = [];
      validJobInfo.forEach((jobInfo) => {
        if (jobInfo.department_id) {
          arrDepartmentIds.push(jobInfo.department_id);
        }
      });
      this.getDepartermentByIds(arrDepartmentIds);
    },

    async getDepartermentByIds(arrDepartmentIds) {
      let resApi;
      if (arrDepartmentIds) {
        resApi = await DepartmentApi.list({
          filters: `id:in:${arrDepartmentIds.join(",")}&disabled=false`,
          limit: arrDepartmentIds.length,
        })
        if (resApi.result.length == 0) {
          resApi = await DepartmentApi.list({
            filters: `disabled=false`,
            limit: 100,
          })
        }
      } else {
        resApi = await DepartmentApi.list({
          filters: `disabled=false`,
          limit: 100,
        })
      }
      if (resApi.result.length == 1)  this.mData.dataForm.publish.department_id = resApi.result[0].id;
      this.listDepaterments = resApi.result;
    },

    async fn_getDocById(id) {
      const documentInApiRes = await DocumentApi.findById(id);
      if (documentInApiRes.result) {
        if (documentInApiRes.result.signers && documentInApiRes.result.signers.length > 0) {
          documentInApiRes.result.signers = documentInApiRes.result.signers.filter(signer => !signer.is_add_auto)
        }
        if (!documentInApiRes.result.publish) documentInApiRes.result.publish = {};
        if (documentInApiRes.result.publish.is_auto && documentInApiRes.result.publish.is_auto == true) {
          if (this.mData.currentProfile.type == "COMPANY") {
            //Lấy về danh sách phòng ban theo tài khoản nhân viên
            this.getListDepartermentByCompanyUser()
          } else {
            //Lấy dữ liệu nhân viên người tạo
            this.getListDepartermentByEmployee();
          }
        }
        this.mData.dataForm = documentInApiRes.result;
        this.fn_eventBus(this.checkTab(this.$route.query.type), 'sign-request', this.mData.dataForm.name)
        if (this.mData.dataForm.signers && this.mData.dataForm.signers.length > 0) {
          this.mData.dataForm.signers = await this.fn_changeDataSigner(this.mData.dataForm.signers);
        } else {
          this.mData.dataForm.signers = [];
        }
        await this.fn_getMainFile();
        await this.fn_checkToSetFileId();
      }
    },

    async fn_getMainFile() {
      if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        const listFile = await FileApi.list(
          {
            filters: `id=${this.mData.dataForm.doc_file.doc_id}`,
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.getDocumentPreviewUrl(item.id);
          });
        }
        this.mData.fileUploadOption.fileMain.fileList = data;
      }
    },

    fn_checkToSetFileId() {
      let fileDetail = {};
      if (this.mData.dataForm.signed_doc_file_id) {
        this.url =
          ExtensionService.getDocumentPreviewUrl(
            this.mData.dataForm.signed_doc_file_id
          );
        this.fileId = this.mData.dataForm.signed_doc_file_id;
      } else if (
        this.mData.dataForm.doc_file &&
        this.mData.dataForm.doc_file.doc_id
      ) {
        fileDetail = this.mData.fileUploadOption.fileMain.fileList[0];
        this.url = ExtensionService.getDocumentPreviewUrl(fileDetail.id);
        this.fileId = fileDetail.id;
      }
    },

    fn_downloadFile() {
      if (this.fileId) {
        window.open(ExtensionService.urlDowloadFile + this.fileId);
      } else {
        this.$notify.warning({
          message: "Không tìm thấy file để tải.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_isLastSignerDirector(signers) {
      if (!Array.isArray(signers) || signers.length === 0) return false;

      const lastSigner = signers[signers.length - 1];
      const companyId = this.mData.currentCompany && this.mData.currentCompany.id;
      const roleFilters = [
        "code=CEO",
        "disabled!=true",
        "is_default=true",
      ];
      if (companyId) roleFilters.push(`company_id=${companyId}`);

      const roleApiRes = await RoleApi.list(
        {
          filters: roleFilters.join("&"),
          fields: "id",
          limit: 100,
        },
        true
      );
      const directorRoleIds = (roleApiRes.result || []).map((role) => role.id);
      if (directorRoleIds.length === 0) return false;

      const employeeRoleFilters = [`employee_id=${lastSigner.user_id}`];
      if (companyId) employeeRoleFilters.push(`company_id=${companyId}`);
      const employeeRoleApiRes = await EmployeeRoleApi.list(
        {
          filters: employeeRoleFilters.join("&"),
          fields: "role_ids",
          limit: 100,
        },
        true
      );

      return (employeeRoleApiRes.result || []).some((employeeRole) =>
        (employeeRole.role_ids || []).some((roleId) =>
          directorRoleIds.includes(roleId)
        )
      );
    },

    async fn_submitForm(type) {
      try {
        let data = this.mData.dataForm;

        if (type == "next-to-sign-request") {
          const isLastSignerDirector = await this.fn_isLastSignerDirector(
            data.signers
          );
          if (!isLastSignerDirector) {
            this.$notify.warning({
              message: "Phải có ít nhất một người ký là Giám đốc trước khi trình ký.",
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }

          this.targetSigner = null;
          this.imgSignId = undefined;
          this.activeProcess = 1;
          this.viewMode = "sign-request";
          this.fn_setStatusForSigner(data.signers);
          // Tự động chọn signer đầu tiên có thể ký sau khi Vue re-render
          this.$nextTick(() => {
            const firstSigner = data.signers.find(s => s.status !== 'SIGNED' && !(s.is_VT && s.is_add_auto));
            if (firstSigner) {
              this.targetSigner = `${firstSigner.user_id}-${firstSigner.position_id}`;
              this.fn_clickTag(firstSigner);
            }
          });
        } else if (type == "sign-request") {
          this.fn_syncCurrentSignerPosition();
          data.signers.forEach((signer) => {
            if (!signer.is_add_auto && signer.position) {
              signer.position = this.fn_toBackendSignPosition(signer.position);
            }
          });
          const objReqSign = {
            id: data.id,
            is_digital_signature: data.is_digital_signature,
            signers: data.signers,
            deadline: data.deadline
              ? new Date(new Date(data.deadline).setHours(23, 59, 59))
              : null,
              department_id: this.mData.dataForm.publish.department_id,
          };
          // console.log('121221', objReqSign)
          await DocumentApi.RequestSignDocument(objReqSign);

          this.$notify.success({
            message: "Trình ký văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          await this.fn_goBack();
        }
      } catch (error) {
        // console.log(error);
        if (error.code) {
          this.$notify.warning({
            message: `${error.message}.`,
            duration: 3000,
            customClass: "doc-warning",
          });
          return;
        }
        this.$notify.warning({
          message: "Trình ký văn bản thất bại.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    // fn_setX và fn_setY đã được thay bằng công thức canvas_px × (96/72) / 1.4
    fn_setX(signer) {
      // Dịch vị trí sang phải -> giảm tham số trừ đi
      return signer.position.x >= 700 && signer.position.y >= 950
        ? signer.position.x - 31
        : signer.position.x >= 650 && signer.position.y >= 950
        ? signer.position.x - 26
        : signer.position.x >= 450 && signer.position.y >= 950
        ? signer.position.x - 28
        : signer.position.x >= 300 && signer.position.y >= 950
        ? signer.position.x - 20
        : signer.position.x >= 150 && signer.position.y >= 950
        ? signer.position.x - 18
        : signer.position.x >= 700 && signer.position.y >= 800
        ? signer.position.x - 34
        : signer.position.x >= 550 && signer.position.y >= 800
        ? signer.position.x - 29
        : signer.position.x >= 400 && signer.position.y >= 800
        ? signer.position.x - 20
        : signer.position.x >= 150 && signer.position.y >= 800
        ? signer.position.x - 8
        : signer.position.x >= 0 && signer.position.y >= 800
        ? (signer.position.x < 3 ? 0 : signer.position.x - 4)
        : signer.position.x >= 700 && signer.position.y >= 500
        ? signer.position.x - 34
        : signer.position.x >= 550 && signer.position.y >= 500
        ? signer.position.x - 29
        : signer.position.x >= 300 && signer.position.y >= 500
        ? signer.position.x - 19
        : signer.position.x >= 150 && signer.position.y >= 500
        ? signer.position.x - 6
        : signer.position.x >= 0 && signer.position.y >= 500
        ? (signer.position.x < 4 ? 0 : signer.position.x - 5)
        : signer.position.x >= 700 && signer.position.y >= 300
        ? signer.position.x - 35
        : signer.position.x >= 550 && signer.position.y >= 300
        ? signer.position.x - 30
        : signer.position.x >= 400 && signer.position.y >= 300
        ? signer.position.x - 15
        : signer.position.x >= 150 && signer.position.y >= 300
        ? signer.position.x - 8
        : signer.position.x >= 0 && signer.position.y >= 300
        ? (signer.position.x == 0 ? 0 : signer.position.x - 1)
        : signer.position.x >= 700 && signer.position.y >= 950
        ? signer.position.x - 34
        : signer.position.x >= 550 && signer.position.y >= 150
        ? signer.position.x - 29
        : signer.position.x >= 400 && signer.position.y >= 150
        ? signer.position.x - 18
        : signer.position.x >= 150 && signer.position.y >= 150
        ? signer.position.x - 6
        : signer.position.x >= 0 && signer.position.y >= 150
        ? signer.position.x
        : signer.position.x >= 700 && signer.position.y >= 0
        ? signer.position.x - 35
        : signer.position.x >= 550 && signer.position.y >= 0
        ? signer.position.x - 30
        : signer.position.x >= 400 && signer.position.y >= 0
        ? signer.position.x - 20
        : signer.position.x >= 150 && signer.position.y >= 0
        ? signer.position.x - 6
        : signer.position.x >= 0 && signer.position.y >= 0
        ? (signer.position.x == 0 ? 0 : signer.position.x - 1)
        : signer.position.x
    },

    fn_setY(signer) {
      // Dịch vị trí lên trên -> tăng tham số trừ đi
      return signer.position.x >= 650 && signer.position.y >= 950
        ? signer.position.y - 55
        : signer.position.x >= 450 && signer.position.y >= 950
        ? signer.position.y - 50
        : signer.position.x >= 300 && signer.position.y >= 950
        ? signer.position.y - 49
        : signer.position.x >= 150 && signer.position.y >= 950
        ? signer.position.y - 50
        : signer.position.x >= 0 && signer.position.y >= 950
        ? signer.position.y - 52
        : signer.position.x >= 550 && signer.position.y >= 800
        ? signer.position.y - 43
        : signer.position.x >= 400 && signer.position.y >= 800
        ? signer.position.y - 46
        : signer.position.x >= 150 && signer.position.y >= 800
        ? signer.position.y - 44
        : signer.position.x >= 0 && signer.position.y >= 800
        ? signer.position.y - 42
        : signer.position.x >= 550 && signer.position.y >= 500
        ? signer.position.y - 28
        : signer.position.x >= 300 && signer.position.y >= 500
        ? signer.position.y - 32
        : signer.position.x >= 150 && signer.position.y >= 500
        ? signer.position.y - 30
        : signer.position.x >= 0 && signer.position.y >= 500
        ? signer.position.y - 28
        : signer.position.x >= 550 && signer.position.y >= 300
        ? signer.position.y - 13
        : signer.position.x >= 400 && signer.position.y >= 300
        ? signer.position.y - 13
        : signer.position.x >= 150 && signer.position.y >= 300
        ? signer.position.y - 15
        : signer.position.x >= 0 && signer.position.y >= 300
        ? signer.position.y - 10
        : signer.position.x >= 550 && signer.position.y >= 150
        ? signer.position.y - 5
        : signer.position.x >= 400 && signer.position.y >= 150
        ? signer.position.y - 3
        : signer.position.x >= 150 && signer.position.y >= 150
        ? signer.position.y - 5
        : signer.position.x >= 0 && signer.position.y >= 150
        ? signer.position.y - 5
        : signer.position.x >= 550 && signer.position.y >= 0
        ? signer.position.y
        : signer.position.x >= 400 && signer.position.y >= 0
        ? signer.position.y + 3
        : signer.position.x >= 150 && signer.position.y >= 0
        ? (signer.position.y == 0 ? 0 : signer.position.y - 1)
        : signer.position.x >= 0 && signer.position.y >= 0
        ? signer.position.y + 3
        : signer.position.y
    },

    async fn_checkRole(dataSignerID) {
      const employeeApiRes = await EmployeeApi.GetEmployeeIdsHaveVTRole({
        signer_ids: dataSignerID
      });
      if (employeeApiRes.result) {
        this.mData.dataForm.signers.forEach(signer => {
          employeeApiRes.result.forEach(idVT => {
            if (idVT == signer.user_id) {
              signer.is_VT = true;
            }
          });
        });
      }
    },

    fn_setStatusForSigner(dataSigner) {
      const listSignerId = dataSigner.map(signer => signer.user_id);
      this.fn_checkRole(listSignerId);

      const indexPersonSigned = dataSigner.findLastIndex(signer => signer.status == "SIGNED");
      dataSigner = dataSigner.map((signer, i) => {
        if (signer.status == 'SIGNED') {
          signer.is_has_sign = true;
          signer.not_change = true;
          dataSigner.forEach(s => {
            if (s.user_id == signer.user_id) {
              s.status = 'SIGNED';
            }
          });
        } else if (signer.status !== 'SIGNED') {
          signer.user_id = signer.id
            ? signer.id
            : signer.user_id
            ? signer.user_id
            : undefined;
          signer.position_id = signer.position_id
          signer.status = i == indexPersonSigned + 1 ? "WAITING" : "NEW";
          signer.is_has_sign = false;
          signer.position = undefined;
          signer.signed_file_id = undefined;
          signer.sign_image_id = undefined;
          signer.not_change = false;
        }
        return signer;
      });

      if (dataSigner[0].status == 'WAITING') {
        dataSigner.forEach(signer => {
          if (signer.user_id == dataSigner[0].user_id) {
            signer.status = 'WAITING';
          }
        });
      } else {
        const waitingSigner = dataSigner.find(signer => signer.status == 'WAITING');
        if (waitingSigner) {
          dataSigner.forEach(signer => {
            if (signer.user_id == waitingSigner.user_id) {
              signer.status = 'WAITING';
            }
          });
        }
      }
    },

    fn_toggleDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },

    changePage(pageNum) {
      this.pageNum = pageNum;
    },

    scrollToTop() {
      document.querySelector(".app-body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    getDefaultVisibleSignPosition(signWidth = 220, signHeight = 160) {
      const pdfContent = this.$el ? this.$el.querySelector(".pdf-content") : null;
      const canvas = pdfContent ? pdfContent.querySelector("canvas") : null;
      if (!pdfContent || !canvas) {
        return { x: 24, y: 24 };
      }

      const offset = 24;
      const maxX = Math.max(0, canvas.width - signWidth);
      const maxY = Math.max(0, canvas.height - signHeight);
      const visibleWidth = Math.min(
        canvas.width,
        pdfContent.clientWidth || canvas.width
      );
      const visibleLeft = Math.max(
        0,
        (canvas.width - visibleWidth) / 2 + (pdfContent.scrollLeft || 0)
      );
      const visibleTop = Math.max(0, pdfContent.scrollTop || 0);

      const x = Math.min(maxX, Math.max(0, visibleLeft + offset));
      const y = Math.min(maxY, Math.max(0, visibleTop + offset));

      return { x, y };
    },

    fn_checkTarget() {
      if (!this.targetSigner) return;
      const target = this.targetSigner.split('-');
      const empId = target[0];
      const posId = target[1];
      const o = this.mData.dataForm.signers.find(
        (signer) => signer.user_id == empId && signer.position_id == posId
      );
      return o;
    },

    async changeSignImage(imageSignId) {
      let isHadSign = false
      const objSigner = this.fn_checkTarget();
      if (
        objSigner &&
        objSigner.position &&
        this.historySign.pageSigned &&
        this.historySign.pageSigned != this.pageNum
      ) {
        isHadSign = true
        this.imgSignId = objSigner.sign_image_id;
        this.$notify.info({
          message: `Vui lòng xóa chữ ký ở trang cũ để chọn chữ ký mới.`,
          duration: 3000,
          customClass: "doc-info",
        });
        return;
      }
      if (imageSignId) {
        this.scrollToTop();
      }
      this.imgSignId = imageSignId;

      const img = new Image();
      img.src = ExtensionService.urlImg + imageSignId;
      await new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
        setTimeout(resolve, 300);
      });

      const displaySize = this.getDefaultDisplaySignSize(img);
      this.historySign.width = displaySize.width;
      this.historySign.height = displaySize.height;
      this.historySign.imageSignId = imageSignId;
      this.historySign.pageSigned = this.pageNum;

      if (!isHadSign) {
        const defaultPosition = this.getDefaultVisibleSignPosition(
          displaySize.width,
          displaySize.height
        );
        this.historySign.positionX = defaultPosition.x;
        this.historySign.positionY = defaultPosition.y;
      }

      this.dataObject.position = {
        delta_x: 0,
        delta_y: 0,
        x: this.historySign.positionX != null ? this.historySign.positionX : 0,
        y: this.historySign.positionY != null ? this.historySign.positionY : 0,
        width: this.historySign.width,
        height: this.historySign.height,
        page_index: this.historySign.pageSigned,
      };

      this.checkHaveHistorySign();

      await this.fn_saveSignPosition();
      await this.fn_checkHasSign();
      await this.fn_checkAllSignersHaveSignImg();
      await this.forceUpdateUI();

      if (
        this.historySign.imageSignId &&
        this.historySign.imageSignId != imageSignId &&
        !isHadSign
      ) {
        this.changedSignImage = true
        this.showChangeSignImage()
      } else {
        this.showChangeSignImage()
      }
    },

    endDragSign(data) {
      this.historySign.imageSignId = data.imageSignId;
      this.historySign.pageSigned = data.pageSigned;
      this.historySign.positionX = data.positionX;
      this.historySign.positionY = data.positionY;
      this.historySign.width = data.width;
      this.historySign.height = data.height;
      this.checkHaveHistorySign();

      this.fn_saveSignPosition();
      this.fn_checkHasSign();
      this.fn_checkAllSignersHaveSignImg();
    },

    // Save sign's position of signers
    fn_saveSignPosition() {
      if (!this.targetSigner) return;
      const target = this.targetSigner.split('-');
      const empId = target[0];
      const posId = target[1];
      this.mData.dataForm.signers.forEach((signer) => {
        if (signer.user_id == empId && signer.position_id == posId) {
          signer.signed_file_id = this.fileId;
          signer.sign_image_id = this.historySign.imageSignId;
          const displayPosition = {
            x: this.historySign.positionX,
            y: this.historySign.positionY,
            width: this.historySign.width,
            height: this.historySign.height,
            page_index: this.historySign.pageSigned,
            __displayNormalized: true,
          };
          const pagePosition =
            this.fn_getPageRelativePreviewPosition(displayPosition);
          signer.position = {
            x: pagePosition.x,
            y: pagePosition.y,
            delta_x: pagePosition.x,
            delta_y: pagePosition.y,
            width: this.historySign.width,
            height: this.historySign.height,
            page_index: this.historySign.pageSigned,
          };
        }
        return signer;
      });
      // console.log('this.mData.dataForm.signers', this.mData.dataForm.signers)
    },

    showChangeSignImage() {
      setTimeout(() => {
        this.changedSignImage = false
        setTimeout(() => {
          EventBus.$emit('changeImageIdEvent')
        }, 100)
      }, 300)
    },

    fn_deleteSignImage() {
      this.imgSignId = undefined;
      this.changedSignImage = true;
      this.haveHistory = false;
      this.historySign = {
        imageSignId: undefined,
        pageSigned: 0,
        positionX: 0,
        positionY: 0,
        width: 220,
        height: 220
      };
      const target = this.targetSigner.split('-');
      const empId = target[0];
      const posId = target[1];
      const index = this.mData.dataForm.signers.findIndex(signer => signer.user_id == empId && signer.position_id == posId);
      if (index >= 0) {
        this.mData.dataForm.signers[index].signed_file_id = undefined;
        this.mData.dataForm.signers[index].sign_image_id = undefined;
        this.mData.dataForm.signers[index].position = undefined;
        this.mData.dataForm.signers[index].is_has_sign = undefined;
      }
    },

    fn_checkHasSign() {
      this.mData.dataForm.signers.forEach((signer) => {
        if (signer.position) {
          signer.is_has_sign = true;
        }
      });
    },

    fn_clickTag(tag) {
      if (tag.not_change || (tag.is_VT && tag.is_add_auto)) return;
      this.isClickTagChooseSignature = true;
      this.changedSignImage = true;
      this.getEmployeeSign("", tag.user_id);
      // const init = {
      //   x: this.dataObject.position && this.dataObject.position.x != null ? this.dataObject.position.x : this.historySign.positionX,
      //   y: this.dataObject.position && this.dataObject.position.y != null ? this.dataObject.position.y : this.historySign.positionY,
      //   width: this.dataObject.position && this.dataObject.position.width != null ? this.dataObject.position.width : this.historySign.width,
      //   height: this.dataObject.position && this.dataObject.position.height != null ? this.dataObject.position.height : this.historySign.height,
      //   page_index: this.pageNum,
      // };

      const o = this.mData.dataForm.signers.find(
        (signer) => signer.user_id == tag.user_id && signer.position_id == tag.position_id
      );

      if (o && o.position) {
        this.applySignerCanvasPosition(o.position);
      } else {
        this.dataObject.position = this.dataObject.position;
      }
      // this.dataObject.page_index = this.pageNum;
      // console.log('ooo', o)
      this.imgSignId = o && o.sign_image_id ? o.sign_image_id : undefined;
      this.showChangeSignImage()
      this.scrollToTop();
    },

    async getEmployeeSign(data, signer_id) {
      data = { user_id: signer_id ? signer_id : this.mData.currentUser.id };
      this.fileUploadOption.FileChuKy.listImageSigns = [];
      const employeeSignatureApiRes = await EmployeeSignatureApi.list({
        filters: `employee_id=${data.user_id}`,
      });
      if (
        employeeSignatureApiRes.result &&
        employeeSignatureApiRes.result.length > 0
      ) {
        if (!employeeSignatureApiRes.result[0].image_ids) {
          employeeSignatureApiRes.result[0].image_ids = [];
        }
        this.listEmployeeSignatures = employeeSignatureApiRes.result[0];
      } else {
        this.listEmployeeSignatures = {
          employee_id: data.user_id,
          image_ids: [],
        };
      }
      (this.listEmployeeSignatures.image_ids || []).forEach((item) => {
        this.fileUploadOption.FileChuKy.listImageSigns.push({
          sign_image_id: item,
          url: ExtensionService.urlImg + item,
        });
      });
    },

    async fn_uploadSign(file, fileList) {
      if (!this.checkTypeImageBeforeUpload(file)) return;
      const res = await ExtensionService.upload(file, "ChuKyNhanVien");
      if (res && res.result) {
        if (!MethodService.checkWidthHeightImage(res.result, 220, 220)) return;
        this.listEmployeeSignatures.image_ids.push(res.result);
        this.fileUploadOption.FileChuKy.listImageSigns.push({
          sign_image_id: res.result,
          url: ExtensionService.urlImg + res.result,
        });
        this.updateEmployeeSign();
      }
    },

    checkTypeImageBeforeUpload(file) {
      if (file.raw && file.raw.type == "image/png") {
        return true;
      } else {
        toastr.warning("Chỉ được tải lên file ảnh có định dạng PNG");
        return false;
      }
    },

    async updateEmployeeSign() {
      try {
        let data = MethodService.copyObject(this.listEmployeeSignatures);
        await EmployeeSignatureApi.update(data);
        // toastr.success("Cập nhật chữ ký thành công");
      } catch (error) {
        toastr.error("Cập nhật chữ ký thất bại");
      }
    },

    handleCanvasDimensions(dimensions) {
      this.canvasDimensions = dimensions;
      const objSigner = this.fn_checkTarget();
      if (
        objSigner &&
        objSigner.position &&
        objSigner.position.page_index === this.pageNum
      ) {
        this.applySignerCanvasPosition(objSigner.position);
        this.showChangeSignImage();
      }
    },

    handlePdfSize(size) {
      this.pdfSize = size;
    },

    changePageNum(data) {
      this.pageNum = data.pageNum;
      this.numPages = data.numPages;
      this.scrollToTop();
      this.dataObject.position.page_index = this.pageNum
      this.changedSignImage = true
      const objSigner = this.fn_checkTarget();
      // console.log('999', objSigner)
      if (
        objSigner &&
        objSigner.position &&
        this.historySign.pageSigned &&
        this.historySign.pageSigned == this.pageNum
      ) {
        // this.historySign.imageSignId = objSigner.sign_image_id;
        this.imgSignId = objSigner.sign_image_id;
        this.applySignerCanvasPosition(objSigner.position);
        this.showChangeSignImage()
      }
    },

    checkHaveHistorySign() {
      this.haveHistory = false;
      if (this.historySign.imageSignId) {
        this.haveHistory = true;
      } else {
        this.haveHistory = false;
      }
    },

    async fn_initData() {
      await Promise.all([
        this.fn_getListConTractType(),
        this.fn_getListPosition(),
        this.fn_getListEmployee()
      ]),
      await this.fn_getDocById(this.$route.params.id);
      await this.fn_getSignRequestHistory();
      await this.fn_getListDataByTab();
      await this.fn_checkSignerEditable(this.listNearestHistory, true);

      // if (this.mData.dataForm.signers.length == 0) {
        this.dataObject.position = {
          x: this.historySign.positionX,
          y: this.historySign.positionY,
          width: this.historySign.width,
          height: this.historySign.height,
          page_index: this.pageNum,
        };
      // }
    },

    fn_goBackPrevious() {
      if (this.viewMode == "sign-request") {
        this.viewMode = "choose-signer";
        this.activeProcess = 0;
        this.fileUploadOption.FileChuKy.listImageSigns = [];
        this.isClickTagChooseSignature = false;
      } else if (this.viewMode == "choose-signer") {
        this.fn_goBack();
      }
    },
  },

  created() {
    this.fn_eventBus(this.checkTab(this.$route.query.type), 'sign-request')
    this.viewMode = "choose-signer";
    this.tabName = "CaNhan";
    this.fn_initData();
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1490px) and (max-width: 1670px) {
  .col-xl-9 {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
@media (min-width: 1336px) and (max-width: 1489px) {
  .col-xl-9 {
    flex: 0 0 62%;
    max-width: 62%;
  }
}
@media (min-width: 1200px) and (max-width: 1335px) {
  .col-xl-9 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
::v-deep .issued-at {
  .bold {
    &::after {
      content: "*";
      color: #f56c6c;
      margin-left: 5px;
      font-weight: bold;
    }
  }
  .el-select {
    width: 220px;
    .el-input__inner {
      padding-right: 30px;
    }
  }
}
::v-deep .body-pdf {
  position: relative;
}
::v-deep #pdf-content {
  margin-left: 0;
}
::v-deep .el-date-editor.el-input {
  width: 220px;
}
::v-deep .el-radio-group {
  .el-radio-button {
    // &:first-child {
    //   margin-left: 12px;
    // }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #000;
      background-color: #ffeadc;
      border-color: #ffeadc;
      box-shadow: -1px 0 0 0 #ffeadc;
    }
  }
  .el-radio-button__inner {
    border: none;
    border-radius: 8px;
    background-color: transparent;
  }
}
::v-deep .empty__tab-text {
  color: #747474;
}
.drawer-container {
  .drawer {
    position: absolute;
    top: 0;
    right: 0;
    background: #d0d5d9;
    width: 25%;
    height: 100%;
    overflow: hidden;
    box-shadow: -3px 0px 2px 0px rgb(0 0 0 / 7%);
    z-index: 99;
  }
  .drawer-collapse {
    position: absolute;
    top: 0;
    right: 0;
    background: #292d32;
    width: 3%;
    height: 100%;
    overflow: auto;
    .drawer__header {
      flex-direction: column;
      background: #292d32;
      .drawer__header-title {
        background: #292d32;
        writing-mode: vertical-rl;
      }
    }
  }
  .drawer__header {
    background: #444242;
    padding: 15px 10px;
    .drawer__header-title {
      color: var(--white);
    }
  }
  .drawer__box {
    height: 96%;
    .drawer__box-title {
      padding: 10px 10px;
      background: #ababab;
      color: #292d32;
    }
    .drawer__box-content {
      padding: 10px;
      max-height: calc(100% - 38px);
      overflow: auto;
    }
  }
}

::v-deep .list-sign-image {
  width: 100%;
  padding: 0 10px;
  // max-height: calc(100vh - 200px);
  overflow-y: auto;
  .radio-group {
    display: flex;
    flex-direction: column;
    .el-radio {
      position: relative;
      .el-radio__input {
        position: absolute;
        top: -3px;
        left: -15px;
        background-color: transparent;
        padding: 7px;
        border-radius: 50%;
        &.is-checked + .el-radio__label {
          color: #5e9bbc;
        }
        &.is-checked {
          .el-radio__inner {
            border-color: #5e9bbc;
            background: #fff;
          }
        }
        .el-radio__inner {
          width: 24px;
          height: 24px;
          border-color: #5e9bbc;
          &:hover {
            border-color: #5e9bbc;
          }
          &::after {
            width: 16px;
            height: 16px;
            background-color: #5e9bbc;
            border-color: #5e9bbc;
          }
        }
      }
    }
    .border-image {
      border: 1.5px solid #5e9bbc;
      border-radius: 2px;
      padding: 10px;
      text-align: center;
      // position: relative;
      .el-image {
        max-width: 300px;
      }
      .el-upload-dragger {
        max-width: 200px;
        height: 200px;
        border-radius: 50%;
        border-width: 2px;
        .el-upload__text {
          line-height: 20px;
        }
      }
    }
  }
}
::v-deep .border-image {
  border: 1.5px solid #5e9bbc;
  border-radius: 2px;
  padding: 10px;
  text-align: center;
  .el-image {
    max-width: 300px;
  }
  .el-upload-dragger {
    max-width: 200px;
    height: 200px;
    border-radius: 50%;
    border-width: 2px;
    .el-upload__text {
      line-height: 20px;
    }
  }
  .el-upload-list {
    display: none;
  }
}
::v-deep .pdf-content {
  width: 100%;
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
}

::v-deep .pdf-content .canvas {
  position: relative;
  width: fit-content;
  margin: 0 auto;
}

::v-deep .dropzone {
  margin: 0 auto;
  position: relative;
  p {
    color: var(--white);
  }
  .current-page {
    width: 50px !important;
    .el-input {
      .el-input__inner {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}
.pdf-container {
  position: relative;
  background: #444242;
  padding: 10px 0 5px;
}
::v-deep .el-steps {
  font-family: "UTM Avo", "san-serif";
  .el-step__head {
    .el-step__icon {
      color: var(--white);
      background-color: #c1c5cc;
    }
    .el-step__line {
      left: 25px;
      right: 10px;
    }
  }
  .el-step__head.is-success,
  .el-step__head.is-process {
    .el-step__icon {
      border-radius: 50%;
      border-color: var(--turquoise);
      background-color: var(--turquoise);
      .el-step__icon-inner {
        color: var(--white);
      }
      .el-icon-check::before {
        content: "1";
        font-family: "UTM Avo", "san-serif";
        font-weight: 700;
        font-size: 13px;
        text-align: center;
        line-height: 1;
        color: var(--white);
      }
    }
  }
  .el-step__main {
    width: max-content;
    padding: 0 10px;
    background-color: #fffaf7;

    position: absolute;
    top: -8px;
    left: 25px;
    .el-step__title.is-success {
      font-weight: bold;
      color: var(--black);
    }
  }
}

::v-deep .theme--light.v-stepper {
  background: transparent;
  &:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .v-stepper__step {
    .v-stepper__step__step {
      font-weight: bold;
      background-color: var(--turquoise);
      margin-right: 5px;
    }
    .v-stepper__label {
      font-weight: bold;
    }
  }
}
::v-deep .main {
  .container-fluid {
    padding: 20px 20px 10px 25px;
  }
}

.preview__file-container {
  background: #bebebe;
  width: 100%;
  height: 100vh;
  box-shadow: 7px 7px 21px -7px rgb(0, 0, 0, 30%);
}
.checked {
  background: #d0e8f5 !important;
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: 3px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-textarea__inner {
  height: calc(100vh - 95px);
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}

::v-deep .el-tabs__nav {
  &:not(.is-active)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 2px;
    background: #d0d5d9;
  }
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .btn-default.dark-green {
  background: var(--dark-green) !important;
  border: 1px solid var(--dark-green) !important;

  &:focus {
    background: var(--dark-green) !important;
  }

  &:hover {
    background: #15c765 !important;
  }

  &:active {
    background: var(--dark-green) !important;
  }
}

::v-deep .btn-default.dark-blue {
  background: var(--dark-blue) !important;
  border: 1px solid var(--dark-blue) !important;

  &:focus {
    background: var(--dark-blue) !important;
  }

  &:hover {
    background: #438eff !important;
  }

  &:active {
    background: var(--dark-blue) !important;
  }
}

::v-deep .icon {
  cursor: pointer;
  font-size: 21px;
}
.el-icon-d-arrow-left,
.el-icon-d-arrow-right {
  font-size: 16px;
  background: #fff;
  border-radius: 1px;
}

::v-deep .isax-trash {
  color: var(--red);
}

::v-deep .isax-eye {
  color: var(--orange);
}

::v-deep .el-dialog__body {
  padding: 0px !important;
}

::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}

::v-deep .datePicker .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}

::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}

::v-deep .el-tag {
  border: none;
  border-radius: 8px;
  background-color: #d0e8f5;
  .el-avatar--small {
    width: 23px;
    height: 23px;
    line-height: 28px;
  }
  .el-icon-close {
    color: var(--black);
    top: 0;
    &:hover {
      color: var(--white);
    }
  }
}
::v-deep .el-tag--small {
  height: 36px;
}

::v-deep .el-divider--horizontal {
  margin: 10px 0;
}
.empty-content {
  height: 500px;
  padding: 200px 0;
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}

::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }

  .el-tabs__item.is-activeProcess {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    // border-right: none;

    span {
      color: black;
      font-weight: bold;
    }

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
.icon-prefix,
.icon-suffix {
  font-size: 21px;
}

::v-deep .el-tabs__content {
  overflow: auto;
  .el-tab-pane {
    height: calc(100vh - 445px);

    // overflow-y: scroll;
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}
</style>

<style lang="scss">
.button-prev {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 5%;
  z-index: 98;
}
.button-next {
  border-radius: 5px;
  position: absolute;
  top: 50%;
  right: 5%;
  z-index: 98;
}
</style>
